/* eslint-disable */
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import Quasar from 'quasar/src/vue-plugin.js';
import axios from 'axios'
import VueAxios from 'vue-axios'
import quasarUserOptions from './quasar-user-options'
import VueFilesPreview from 'vue-files-preview'
import 'vue-files-preview/lib/style.css'

createApp(App).use(Quasar, quasarUserOptions).use(router).use(VueAxios, axios).use(createPinia()).use(VueFilesPreview).mount('#app')
